import {
    GridCallbackDetails,
    GridColDef,
    GridPaginationModel,
    GridRowParams,
    GridSortModel,
} from '@mui/x-data-grid';

import {
    DataGrid,
    DataGridCard,
    dataGridNestedObjectValueGetter,
} from '@barboxx/admin-components';
import { Product } from '@barboxx/models';
import { FLAVOR_TYPES } from '@barboxx/types';
import { enumToFormOptions } from '@barboxx/utils';

const COLUMNS: GridColDef<Product>[] = [
    { field: 'id', headerName: 'Id', width: 70 },
    {
        field: 'brand.name',
        headerName: 'Brand',
        width: 200,
        valueGetter: dataGridNestedObjectValueGetter,
    },
    { field: 'name', headerName: 'Name', width: 200, flex: 1 },
    {
        field: 'productType.name',
        headerName: 'Alcohol Type',
        width: 170,
        valueGetter: dataGridNestedObjectValueGetter,
    },
    {
        field: 'productSubtype.name',
        headerName: 'Alcohol Subtype',
        width: 170,
        valueGetter: dataGridNestedObjectValueGetter,
    },
    {
        field: 'isAlcoholic',
        headerName: 'Is Alcoholic',
        width: 100,
        type: 'boolean',
    },
    {
        field: 'flavor',
        headerName: 'Flavor',
        width: 200,
        type: 'singleSelect',
        valueOptions: enumToFormOptions(FLAVOR_TYPES),
    },
];

interface Props {
    data: Product[];
    size: number;
    page: number;
    total: number;
    onRowClick: (id: string) => void;
    onChangeSort: (sort: GridSortModel) => void;
    handleChangePageModel: (
        model: GridPaginationModel,
        details: GridCallbackDetails
    ) => void;
}

export function ProductTable(props: Props) {
    const {
        data = [],
        total,
        size,
        page,
        onRowClick,
        handleChangePageModel,
        onChangeSort,
    } = props;

    const handleRowClick = (param: GridRowParams) => {
        onRowClick(param.id as string);
    };

    return (
        <DataGridCard title="Products">
            <DataGrid
                rows={data}
                columns={COLUMNS}
                paginationModel={{
                    page,
                    pageSize: size,
                }}
                onPaginationModelChange={handleChangePageModel}
                rowCount={total}
                disableColumnMenu
                onRowClick={handleRowClick}
                onSortModelChange={onChangeSort}
            />
        </DataGridCard>
    );
}
